module.exports = __webpack_public_path__ + "static/media/Golduck_gaussian2.5d59f53c.png";